// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pwa-banner[data-v-4388fe62]{align-items:center;background-color:#f83;border-radius:5px;box-shadow:0 2px 12px 0 rgba(255,136,51,.5);color:#fff;display:flex;height:140px;justify-content:center;margin:0 auto;text-align:center;width:280px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
